import { Model } from 'oderon-vue'
import { brDateTime } from 'oderon-commons/src/formatters'
import grid from 'oderon-commons/src/grid'
import { preProcessSpec } from 'oderon-commons/src/tables'

export function translateType(row) {
  let t = row.type,
    s = row.subType

  if (t == 'creation') {
    if (s == 'manual') return 'Criação ─ Manual'
    else return 'Criação ─ Automática'
  }

  if (t == 'logistic') return 'Logística'

  if (t == 'firmwareUpdate') {
    if (s == 'manual') return 'Firmware Update ─ Manual'
    else return 'Firmware Update ─ Automático'
  }

  if (t == 'lease') {
    if (s == 'start') return 'Concessão ─ Início'
    else return 'Concessão ─ Fim'
  }

  if (t == 'association') {
    if (s == 'start') return 'Associação ─ Início'
    else return 'Associação ─ Fim'
  }

  if (t == 'installation') {
    if (s == 'install') return 'Instalação'
    if (s == 'remove') return 'Retirada'
    else return 'Intervenção'
  }

  if (t == 'troubleshooting') {
    if (s == 'identify') return 'Identificação de Problema'
    else return 'Resolução de Problema'
  }

  if (t == 'billing') return 'Ajuste de Billing'
  if (t == 'rename') return 'Troca de Placa'

  if (t == 'loss') {
    if (s == 'scrap') return 'Baixa ─ Sucata'
    if (s == 'obsolete') return 'Baixa ─ Obsoleto'
    if (s == 'lost') return 'Baixa ─ Extravio'
    return 'Baixa de Módulo'
  }

  if (t == 'checklist') return 'Checklist de verificação'
  if (t == 'associateTicket') return 'Associação de ticket'

  return `?? ${t} ${s}`
}

export function translateColor({ type: t, subType: s }) {
  if (t == 'creation') return 'black'
  if (t == 'logistic') return 'green'
  if (t == 'firmwareUpdate') return 'green'
  if (t == 'associateTicket') return 'orange'
  if (t == 'loss') return 'black'
  if (t == 'checklist') return 'green'

  if (t == 'lease') {
    if (s == 'start') return 'green'
    else return 'red'
  }

  if (t == 'association') {
    if (s == 'start') return 'green'
    else return 'red'
  }

  if (t == 'installation') {
    if (s == 'install') return 'green'
    if (s == 'remove') return 'red'
    else return 'orange'
  }

  if (t == 'troubleshooting') {
    if (s == 'identify') return 'orange'
    else return 'green'
  }

  // if (t == 'billing') return 'Ajuste de Billing'
  // if (t == 'rename') return 'Troca de Placa'

  return 'black'
}

export const ClientHistory = new Model('/history')

const fullSpec = preProcessSpec([
  { t: 'ID|', d: 'id', sortBy: false },
  { t: 'Módulo|', d: 'clientId', sortBy: false },
  { t: 'Veículo', d: 'vehicleCode', sortBy: false },
  { t: 'Org', d: 'org.label', sortBy: false },
  { t: 'Timestamp', d: 'timestamp', f: brDateTime, sortBy: false },
  { t: 'Tipo', d: (row) => translateType(row), sortBy: false },
  { t: 'Login', d: 'login', sortBy: false }
])

ClientHistory.getGridSpec = () => fullSpec
ClientHistory.getGrid = async (ps) => {
  let { rows, count } = await ClientHistory.findAll(ps)
  return grid.generateWebGrid({
    rows,
    spec: fullSpec,
    count
  })
}
